import React, { memo } from 'react'
import { Typography, makeStyles, Drawer, DrawerProps } from 'transfix-ui/core'

export interface ISidePanelProps extends Pick<DrawerProps, 'PaperProps' | 'anchor' | 'onClose'> {
  /**
   * @example 'Settings'
   */
  title?: string
  /**
   * @example <CloseIcon />
   */
  menuItems?: React.ReactNode
  children: React.ReactNode
}

const useSidePanelStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
  },
  menuBar: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '2px',
  },
}))

const SidePanel = memo<ISidePanelProps>(
  ({ PaperProps, anchor, children, menuItems, onClose, title }) => {
    const classes = useSidePanelStyles()

    const keyDownHandler = (event: React.KeyboardEvent<{}>) => {
      const { key } = event || {}
      if (key === 'Escape' && onClose) {
        onClose(event, 'escapeKeyDown')
      }
    }

    const backdropClickHandler = (event: React.MouseEvent<{}>) => {
      if (onClose) {
        onClose(event, 'backdropClick')
      }
    }

    return (
      <Drawer
        open
        anchor={anchor}
        onClose={onClose}
        onKeyDown={keyDownHandler}
        onBackdropClick={backdropClickHandler}
        PaperProps={{ style: { width: '30%' }, ...PaperProps }}
        variant='temporary'>
        <div className={classes.root}>
          <div className={classes.menuBar}>
            <Typography variant='h3' component='div'>
              {title}
            </Typography>
            {menuItems}
          </div>
          {children}
        </div>
      </Drawer>
    )
  }
)

export default SidePanel
